export const homeEvents = {
  most_recent_click: "academy_home_hero_most_recent" as const,
  category_click: "academy_home_body_category" as const,
};

export type HomeEvents = typeof homeEvents;
